/*
  Alma Velari: "Combinalo con" del cajon del carrito.

  Vive en un archivo aparte y NO dentro del snippet a proposito. El snippet solo
  se pinta cuando hay algo en el carrito, asi que en la primera carga de una
  ficha con el carrito vacio no llega al HTML; y cuando llega, llega dentro del
  repintado del cajon, que se hace con innerHTML y NO ejecuta los <script> que
  contiene. Con la definicion aqui, cargada siempre, el elemento se activa solo
  en cuanto aparece en el DOM, venga de donde venga.

  Comprobado: con el guion dentro del snippet los botones de talla no hacian
  nada, porque el elemento nunca llegaba a definirse.
*/
// Se define una sola vez. El cajon se repinta con innerHTML y los 
  // insertados asi NO se ejecutan, pero un elemento propio ya definido si se
  // activa solo al entrar en el DOM: por eso la logica va en un custom element
  // y no en un listener suelto.
  customElements.get('av-sugiere-carrito') ||
    customElements.define(
      'av-sugiere-carrito',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', (evento) => {
            // Abrir las tallas de una tarjeta cierra las de las demas: con el
            // carrusel estrecho, dos abiertas a la vez descuadran la fila.
            const abrir = evento.target.closest('[data-av-abrir]');
            if (abrir) {
              const tarjeta = abrir.closest('.av-sugiere__item');
              const abierta = tarjeta.classList.contains('av-sugiere__item--abierto');
              this.querySelectorAll('.av-sugiere__item--abierto').forEach((otra) => {
                otra.classList.remove('av-sugiere__item--abierto');
                const b = otra.querySelector('[data-av-abrir]');
                if (b) b.setAttribute('aria-expanded', 'false');
              });
              if (!abierta) {
                tarjeta.classList.add('av-sugiere__item--abierto');
                abrir.setAttribute('aria-expanded', 'true');
                // Que la tarjeta quede a la vista al desplegarse.
                tarjeta.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
              }
              return;
            }

            const boton = evento.target.closest('[data-av-variante]');
            if (boton) this.agregar(boton);
          });
        }

        agregar(boton) {
          if (this.ocupado) return;
          this.ocupado = true;
          boton.classList.add('av-sugiere__talla--cargando');

          const cajon = document.querySelector('cart-drawer');
          // Se piden las mismas secciones que el propio cajon sabe repintar,
          // para que el contador de la cabecera y la barra de descuento se
          // actualicen en la misma respuesta.
          const secciones = cajon
            ? cajon.getSectionsToRender().map((s) => s.id)
            : ['cart-drawer', 'cart-icon-bubble'];

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(boton.dataset.avVariante), quantity: 1 }],
              sections: secciones,
              sections_url: window.location.pathname,
            }),
          })
            .then((r) => r.json())
            .then((estado) => {
              // Cuando Shopify rechaza el alta devuelve "status" con el codigo.
              if (estado.status) throw new Error(estado.description || estado.message);
              if (cajon && estado.sections) {
                cajon.renderContents(estado);
                return;
              }
              window.location.reload();
            })
            .catch(() => {
              boton.classList.remove('av-sugiere__talla--cargando');
              boton.classList.add('av-sugiere__talla--error');
              this.ocupado = false;
            });
        }
      }
    );
